import { STRINGS } from '@/constants/strings';
import {
  avatarRule,
  cityRule,
  emailRule,
  nameRule,
  optionalPhoneRule,
  requiredPhoneRule,
  zipCodeRule,
} from '@/validation';
import * as yup from 'yup';

/** Reuse the shared mutate-player validation copy (identical wording) so the
 *  guardian / player / coach forms stay consistent. */
export const MESSAGES = STRINGS.mutatePlayer.validation;

/** Guardian onboarding step 1 — profile (name, relationship, contact + address). */
export const onboardingProfileSchema = yup
  .object({
    firstName: nameRule(MESSAGES.fieldRequired),
    lastName: nameRule(MESSAGES.fieldRequired),
    role: yup.string().trim().required(MESSAGES.fieldRequired),
    phoneNumber: requiredPhoneRule(MESSAGES.fieldRequired, MESSAGES.phoneNumberDigitsRange),
    countryCode: yup.string().optional().nullable(),
    altPhoneNumber: optionalPhoneRule(MESSAGES.altPhoneNumberDigitsRange).defined(),
    altCountryCode: yup.string().optional().nullable(),
    email: emailRule(MESSAGES.fieldRequired, MESSAGES.emailInvalid),
    // Holds the ISO code (e.g. "US"); mapped to the country name when sent to the API.
    country: yup.string().trim().defined(),
    city: cityRule(),
    state: yup.string().trim().defined().nullable(),
    zipCode: zipCodeRule(),
    avatar: avatarRule(MESSAGES.fieldRequired, MESSAGES.avatarTooLarge),
  })
  .required();

export type OnboardingProfileForm = {
  firstName: string;
  lastName: string;
  role: string;
  phoneNumber: string;
  countryCode?: string | null;
  altPhoneNumber: string;
  altCountryCode?: string | null;
  email: string;
  country: string;
  city: string;
  state: string | null;
  zipCode: string;
  avatar?: { uri: string; fileSize?: number } | null;
};

export const INITIAL_ONBOARDING_PROFILE_FORM: OnboardingProfileForm = {
  firstName: '',
  lastName: '',
  role: 'parent',
  phoneNumber: '+1',
  countryCode: null,
  altPhoneNumber: '',
  altCountryCode: null,
  email: '',
  country: '',
  city: '',
  state: null,
  zipCode: '',
  avatar: null,
};
